export default (theme) => ({
  circleLoader: {
    color: theme.colorPalette.white_10
  },
  spacing: {
    marginLeft: theme.spacing(2)
  }
});
